<template>
  <full-width>
    <back-button />
    <centralized>
      <img
        src="@/assets/img/home-collect-free-masks.png"
        class="w-32 mx-auto"
      />
      <h2
        class="flex items-center justify-center mt-4 text-2xl font-bold tracking-tight text-center tmsk-blue-text"
      >
        Collect Free Masks
        <tooltip>
          <p data-e2e-attr="free-mask-tooltip">Pre-order period: {{ preOrderPeriod }}</p>
          <p data-e2e-attr="free-mask-tooltip">Collection period: {{ collectionPeriod }}</p>
          <p class="mt-4" data-e2e-attr="free-mask-tooltip">
            For details on free mask collection eligibility, pre-order quota, and locations, click
            <a
              data-e2e-attr="free-mask-tooltip-detail-link"
              class="font-bold underline cursor-pointer"
              :href="cheatSheetUrl"
              target="_blank"
            >
              here</a
            >.
          </p>
          <p v-if="isPreOrderActive" class="mt-4" data-e2e-attr="collect-free-masks-page-pre-order-link">
            To purchase additional mask, select
            <a
              data-e2e-attr="collect-free-masks-page-pre-order-link"
              class="font-bold underline cursor-pointer"
              @click="
                () => $router.push({ name: 'Purchase', query: $route.query })
              "
              target="_blank"
              >'Pre-order'</a
            >
            in the menu.
          </p>
          <p class="mt-4" data-e2e-attr="free-mask-tooltip">
            One free mask per government-issued ID. No refunds or exchanges after collection for hygiene reasons. Please choose the correct mask size (find out your mask size
            <a
              class="font-bold underline cursor-pointer"
              @click="() => goToExternalLink(`http://stayprepared.sg/sizing-guide`)"
            >
              here</a
            >).
          </p>
        </tooltip>
      </h2>
      <div class="flex flex-row flex-wrap justify-center max-w-xl mx-auto mt-10">
        <div class="flex items-center justify-center w-1/3 mr-2 mask-icon-container">
          <div class="w-full h-auto">
            <img  data-e2e-attr="free-mask-image"
                  src="@/assets/img/SM6_MASK_M.png"
                  class="w-full ml-2" />
          </div>
          <div class="w-full h-auto">
            <img data-e2e-attr="free-mask-image"
                  src="@/assets/img/SM6_MASK_L.png"
                  class="w-full -ml-2" />
          </div>
        </div>
        <ol
          class="w-full p-4 mt-2 space-y-3 text-sm text-white list-decimal rounded-lg md:w-3/5 md:mt-0 tmsk-blue-bg"
        >
          <li class="ml-4">Visit any StayMasked vending machine island-wide</li>
          <li class="ml-4" data-e2e-attr="free-mask-redeem-info">
            Bring your ID* (NRIC, Work Permit or FIN, School Smartcard, Driving Licence, Singapore Birth Certificate), PAssion Card or Pioneer/Merdeka Generation Card and scan the barcode
            <div>*For use by adults only. Please measure your size before collection (see sizing guide <a class="font-bold underline cursor-pointer" href='https://stayprepared.sg/sizing-guide' target="_Blank">here</a>).</div>
          </li>
        </ol>
      </div>
      <p class="w-full max-w-xl mx-auto mt-8 text-center text-red-600" data-e2e-attr="free-mask-refund">
        No refunds or exchanges after collection for hygiene reasons. Please choose the correct mask size.
      </p>

      <card
        class="mx-auto mt-10 cursor-pointer w-72 wrap:w-96"
        :onClick="
          () =>
            goToExternalLink(
              'http://stayprepared.sg/sizing-guide'
            )
        "
      >
        <template #body>
          <div class="flex flex-row items-center justify-start space-x-4">
            <img src="@/assets/img/home-size-chart.png" class="h-16" />
            <p class="flex-1 text-xl font-bold tmsk-blue-text">
              Mask Sizing Guide
            </p>
          </div>
        </template>
      </card>
      <card
        class="mx-auto mt-10 cursor-pointer w-72 wrap:w-96"
        :onClick="
          () =>
            $router.push({
              name: 'LocateVendingMachines',
              query: $route.query,
            })
        "
      >
        <template #body>
          <div class="flex flex-row items-center justify-start space-x-4">
            <img
              src="@/assets/img/home-locate-vending-machines.png"
              class="h-16"
            />
            <p class="flex-1 text-xl font-bold tmsk-blue-text">
              Locate Vending Machines
            </p>
          </div>
        </template>
      </card>
    </centralized>
  </full-width>
</template>

<script>
import { mapGetters } from 'vuex'

import Card from '../../components/Card'
import BackButton from '../../components/BackButton'
import FullWidth from '../../components/Layout/FullWidth'
import Centralized from '../../components/Layout/Centralized'
import Tooltip from '../../components/Tooltip'
import { PREORDER_PERIOD, COLLECTION_PERIOD, CHEATSHEET_URL } from '../../Constants'
export default {
  name: 'CollectFreeMasks',
  metaInfo () {
    return {
      title: 'Collect Free Masks',
      // meta: [
      //   { property: 'og:title', content: 'Collect Free Masks' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'Collect Free Masks' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-02.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    FullWidth,
    Centralized,
    Card,
    BackButton,
    Tooltip
  },
  mixins: [],
  props: {},
  data () {
    return {}
  },
  beforeCreate () {},
  created () {
    this.preOrderPeriod = PREORDER_PERIOD
    this.collectionPeriod = COLLECTION_PERIOD
    this.cheatSheetUrl = CHEATSHEET_URL
  },
  beforeMount () {},
  computed: {
    ...mapGetters(['isPreOrderActive'])
  },
  watch: {},

  methods: {
    goToExternalLink (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.mask-icon-container {
  min-width: 200px
}
</style>
